export default __webpack_public_path__ + "static/map-9654590fcd15fe0316f958bb4148ddc0.svg";